



















































import Vue from 'vue'
import { AddOnCarouselElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'AddOnCarouselEl2',

  methods: {
    replaceNewLine (text: string): string {
      if (text.includes('\n')) {
        return text.replace(/\n/g, '<br>')
      }
      return text
    }
  },

  props: {
    templateItemData: {
      type: Object as () => AddOnCarouselElInterface,
      required: true
    }
  }
})
